module.exports = __webpack_public_path__ + "img/hashtag.112b7769.svg";